module.exports = __webpack_public_path__ + "fonts/segoeuii.ac2711bc.ttf";